import { TranslationConfig } from 'react-utilities';

export const FEATURE_NAME = 'AccountSecurityPrompt' as const;
export const LOG_PREFIX = 'Account Security Prompt:' as const;
export const ROOT_ELEMENT_ID = 'account-security-prompt-container' as const;

// This will be sent when we redirect to the account settings so that we
// know that it's a redirect and not an organic entry to the account settings.
// In this case we won't show the prompt again but instead enable authenticator.
export const REDIRECT_URL_SIGNIFIER = 'authpopup' as const;

// This is the authenticator upsell path on Account Settings.
export const ACCOUNT_SETTINGS_SECURITY_PATH = '/my/account#!/security?src=';

// We won't open the authenticator upsell if we're already in Account Settings.
export const ACCOUNT_SETTINGS_URL = 'my/account#!' as const;

// Constants used in specific contexts:
export const CHANGE_PASSWORD_SUGGESTED_CHARACTER_COUNT = 8 as const;
export const DAYS_REMAINING_TO_FORCE_RESET_DEFAULT = 14 as const;
export const FORGOT_PASSWORD_SUPPORT_LINK = 'https://en.help.roblox.com/hc/articles/203313070-I-Forgot-My-Password' as const;
// The domain of the help site describing how to set up 2FA.
export const HELP_SITE_DOMAIN =
  'https://en.help.roblox.com/hc/articles/212459863-Add-2-Step-Verification-to-Your-Account';

/**
 * Constants for event stream events.
 */
export const EVENT_CONSTANTS = {
  eventName: 'accountSecurityPromptEvent',
  context: {
    modalStateViewed: 'modalStateViewed'
  }
} as const;

/**
 * Translations required by this web app (remember to also edit
 * `bundle.config.js` if changing this configuration).
 */
export const TRANSLATION_CONFIG: TranslationConfig = {
  common: [],
  feature: 'Feature.AccountSecurityPrompt'
};
